import numeral from 'numeral'
import 'numeral/locales/de'

numeral.locale('de')

console.log(`Numeral.js locale is [${numeral.locale()}].`)
